import { createAsyncThunk } from "@reduxjs/toolkit";
import { showSnackbar } from "../../snackbar/Snackbar.slice";
import { get, del } from "../../../services/apiService";

const BILLING_INFO_LIST = "billingInfo/list";
const BILLING_INFO_DELETE = "billingInfo/delete";

export const getBillingInfoList = createAsyncThunk(
  BILLING_INFO_LIST,
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const { token, page = 1, page_size = 5, merchantID = null, search } = payload;
      const url = "/billing-info";
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page,
          page_size,
          ...(merchantID && { merchant_id: merchantID }),
          ...(search && { search }),
        },
      };
      const result = await get(url, config);
      return {
        billingInfoList: result.data || [],
        page: result.page || page,
        page_size: result.page_size || page_size,
        total_pages: result.total_pages || 0,
        total_records: result.total_records || 0,
      };
    } catch (error) {
      console.error("Error getting billing info list thunk:", error);
      const fallback = "Unable to load billing information. Please try again.";
      dispatch(
        showSnackbar({
          message: fallback,
          severity: "error",
        })
      );
      return rejectWithValue({
        message: fallback,
      });
    }
  }
);

export const deleteBillingInfo = createAsyncThunk(
  BILLING_INFO_DELETE,
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const { token, billingInfoId, page, page_size, merchantID, search } = payload;
      const url = `/billing-info/${billingInfoId}`;
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      await del(url, config);

      dispatch(
        showSnackbar({
          message: "Billing info archived successfully",
          severity: "success",
        })
      );

      // Recargar la lista después de eliminar
      dispatch(
        getBillingInfoList({
          token,
          page,
          page_size,
          merchantID,
          search,
        })
      );

      return { id: billingInfoId };
    } catch (error) {
      console.error("Error deleting billing info thunk:", error);
      dispatch(
        showSnackbar({
          message:
            error.response?.data?.detail ||
            error.message ||
            "Error deleting billing info",
          severity: "error",
        })
      );
      return rejectWithValue({
        message:
          error.response?.data?.detail ||
          error.message ||
          "Error deleting billing info",
      });
    }
  }
);
